import React, { useState } from 'react';
import { IonAlert, IonToast } from '@ionic/react';

/* Event Bus */
import EventBus from '../services/EventBus';

const SnackBarNotifications: React.FC = () => {
  const [alertMessage, setAlertMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  EventBus.error.on((message) => {
    setAlertMessage(message);
  });

  EventBus.success.on((message) => {
    setSuccessMessage(message);
  });

  return (
    <>
      <IonAlert
        isOpen={!!alertMessage}
        onDidDismiss={() => setAlertMessage('')}
        header={"Une erreur s'est produite."}
        message={alertMessage}
        buttons={['OK']}
      />
      <IonToast
        mode="md"
        isOpen={!!successMessage}
        onDidDismiss={() => setSuccessMessage('')}
        message={successMessage}
        duration={2500}
        color="primary"
      />
    </>
  );
};

export default SnackBarNotifications;
